import { OnBoardingStepEntity } from '../entities/on-boarding-step-entity';

export default class State {
  created_steps: Array<OnBoardingStepEntity> = [];
}
